import React from 'react';

import { Container, LogoContainer } from './styles';

import logo from 'resource/img/logo.png';
import MenuList from '../menu-list';

const tools = [
  {
    text: 'Intimações da AASP',
    to: 'intimacoes-aasp',
  },
  {
    text: 'Lista de Recortes',
    to: 'acompanhar-agenda',
  },
  {
    text: 'Novo Recorte',
    to: 'novo-recorte',
  },
];

const about = [
  {
    text: 'Missão, Visão e Valores',
    to: '/proposito',
  },
  {
    text: 'Contato',
    to: '/contato',
  },
];

const policies = [
  {
    text: 'Termo de Uso',
    to: '/termos-de-uso',
  },
  {
    text: 'Política de Cookies',
    to: '/politica-de-cookies',
  },
];

function Footer() {
  return (
    <Container>
      <div className="container-footer">
        <div className="menus">
          <LogoContainer className="logo-container">
            <img className="img" src={logo} alt="Juslabore Logo" />
            <span className="title">Juslabore</span>
          </LogoContainer>

          <div className="menu">
            <MenuList title="Ferramentas" links={tools} />
          </div>
          <div className="menu">
            <MenuList title="Sobre" links={about} />
          </div>
        </div>
        <div className="navbar">
          <MenuList isHorizontal links={policies} />
          Copyright &copy; {new Date().getFullYear()} Juslabore
        </div>
      </div>
    </Container>
  );
}

export default Footer;
